import {
    _axios as request
} from "../../plugins/axios";

const actions = {
    //获取商品类别
    getProductCategories() {
        return new Promise((resolve, reject) => {
            request({
                url: '/item/class/getList',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    addCategories(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/class/add',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //上架
    onShelfProduct(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/onSale',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //下架
    offShelfProduct(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/offSale',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //删除
    deleteProduct(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/delete',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //撤回审核，平台
    withdrawPending(_,data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/withdrawPending',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //编辑后重新提交审核
    requestRecheck(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/requestRecheck',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    //新建一个商品
    addProductBySpu(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/add',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    新建一个商品的规格
    addProductBySku(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/add',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    编辑库存
    setStock(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/setStock',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    可售
    getNewList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getCheckedList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    已下架
    getOffSaleList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getOffSaleList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    已上架
    getOnSaleList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getOnSaleList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    已售罄
    getOutOfStockList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getOutOfStockList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    待审核
    getPendingOrUncheckedList(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getPendingOrUncheckedList',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    分类内的全部商品
    getListByClass(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/getListByClass',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    上传图片
    uploadImg(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/file/uploadImg',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    编辑，sku级别
    editProductBySku(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/modify',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    编辑，spu级别
    editProductBySpu(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/modify',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    搜索
    searchByKeyAndClassIdAndStatus(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/sku/searchByKeyAndClassIdAndStatus',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    删除分类
    deleteCategory(_,data) {
        return new Promise((resolve, reject) => {
            request({
                url: '/item/class/delete',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    修改商品类别顺序
    editCategoriesPriority(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/class/modifyPriority',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    修改商品分类名称
    editCategoriesName(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/class/modify',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    优惠活动列表
    getPromotionList(){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/promotion/getList',
                method: 'get',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    给商品添加优惠活动
    removePromotion(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/removeFromPromotion',
                method: 'post',
                params: data.promotionId,
                data: data.arr,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    删除已选优惠活动
    putOnPromotion(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/putOnPromotion',
                method: 'post',
                params: data.promotionId,
                data: data.arr,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    覆盖目前参加的活动
    submitPromotionList(_, data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/overridePromotion',
                method: 'post',
                data: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    置顶某商品
    pinProductBySpuId(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/pin',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
//    取消置顶
    unpinProductBySpuId(_,data){
        return new Promise((resolve, reject) => {
            request({
                url: '/item/spu/unpin',
                method: 'post',
                params: data,
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }
}

export default {
    namespaced:true,
    actions,
}

